module.exports = __webpack_public_path__ + "img/20200414142547260.1db70abc.png";